export default __webpack_public_path__ + "381230208de93994a63a14d02882f6e1.mp4";